<template lang="pug">
alert-component
component(:is="$route.meta.layout || 'div'")
  RouterView(:key="$route.fullPath")
  alert-modal(ref="alert-modal")
  bb-confirm(ref="bb-confirm")
  didbuys-item-review(v-if="didbuyAuditLog.length" ref="didbuys-item-review")
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { useDidbuyAuditLogStore } from '@/stores/didbuy-audit-log.js'
import { useFeatureFlagsStore } from './stores/feature-flags'
import { useMobileReport } from '@/composables/useMobileReport'

export default defineComponent({
  setup() {
    const { isMobileReportView } = useMobileReport()
    return {
      isMobileReportView
    }
  },
  data() {
    return {
      didbuyAuditLog: [],
      didbuyAuditLogStore: useDidbuyAuditLogStore()
    }
  },
  created() {
    this.handleRouteChange()
    this.didbuyAuditLog = this.didbuyAuditLogStore.didbuyAuditLog
    useFeatureFlagsStore()
      .getFeatureFlags()
      .catch(() => {})
  },
  beforeUnmount() {
    document.body.classList.remove('mobile-report-view')
  },
  methods: {
    handleRouteChange() {
      if (this.isMobileReportView) {
        document.body.classList.add('mobile-report-view')
      } else {
        document.body.classList.remove('mobile-report-view')
      }
    }
  },
  watch: {
    $route() {
      this.handleRouteChange()
    },
    'didbuyAuditLogStore.didbuyAuditLog': {
      deep: true,
      handler(newVal) {
        this.didbuyAuditLog = newVal
      }
    }
  }
})
</script>
